import { Theme } from '@mui/material/styles'

export default function tabOverride(theme: Theme): object {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down('md')]: {
            padding: '8px 12px',
          },
        },
      },
    },
  }
}
